import type { TransactionViewPortal } from 'mmfintech-backend-api/types'
import { formatMoney, tr } from 'mmfintech-commons'

export function formatExchangeDescription({ exchangeDetails }: TransactionViewPortal) {
  const { fromAmount, fromCurrency = '', toAmount, toCurrency = '', rate } = exchangeDetails || {}
  if (!rate) return null

  return {
    summary: tr('FRONTEND.TRANSACTIONS.DESCRIPTION.EXCHANGE', 'From {{FROM_AMOUNT}} to {{TO_AMOUNT}}', {
      FROM_AMOUNT: formatMoney(fromAmount, fromCurrency),
      TO_AMOUNT: formatMoney(toAmount, toCurrency)
    }),
    rate: tr(
      'FRONTEND.TRANSACTIONS.DESCRIPTION.EXCHANGE_RATE_ONLY',
      '(1 {{FROM_CURRENCY}} = {{FX_RATE}} {{TO_CURRENCY}})',
      {
        FROM_CURRENCY: fromCurrency,
        FX_RATE: rate,
        TO_CURRENCY: toCurrency
      }
    )
  }
}
